module.exports = __webpack_public_path__ + "img/Photo3.28862f38.jpg";